/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Waitlisted_PlayerInputs */



/**
* | output |
* | --- |
* | "You're on the waitlist. You can check in once an organizer gives you a seat." |
*
* @param {Tournament_Waitlisted_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_waitlisted_player = /** @type {((inputs?: Tournament_Waitlisted_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Waitlisted_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes en liste d'attente. Vous pourrez pointer dès qu'un organisateur vous aura accepté.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Está en lista de espera. Podrá hacer check-in cuando un organizador le admita.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você está na lista de espera. Poderá fazer check-in quando um organizador admitir você.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei in lista d'attesa. Potrai fare il check-in quando un organizzatore ti avrà ammesso.")
	return /** @type {LocalizedString} */ ("You're on the waitlist. You can check in once an organizer gives you a seat.")
});